import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ResetConfirm() {
  const [sp] = useSearchParams();
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/auth/reset-confirm", { token: sp.get("token"), password: pw }); toast.success("Password updated. Please log in."); nav("/login"); }
    catch (err) { toast.error(err?.response?.data?.detail || "Reset failed"); }
    setBusy(false);
  };
  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="reset-confirm-page">
      <h1 className="font-heading text-4xl mb-2">Set a new password.</h1>
      <form onSubmit={submit} className="space-y-4 mt-6">
        <Input type="password" placeholder="New password" value={pw} onChange={e=>setPw(e.target.value)} required minLength={6} data-testid="reset-new-pw" className="rounded-xl" />
        <Button type="submit" disabled={busy} className="w-full rounded-full bg-black text-white btn-pill" data-testid="reset-confirm-submit">{busy ? "Updating…" : "Update password"}</Button>
      </form>
    </div>
  );
}
